import * as React from 'react';
import { ArticleParagraph3 } from '@cian/ui-kit';
import * as styles from './NewBuildingLabels.css';

interface INewBuildingLabelsProps {
  labels: string[];
}

export function NewBuildingLabels({ labels }: INewBuildingLabelsProps) {
  return (
    <ul className={styles['labels']}>
      {labels.map((label, index) => (
        <li className={styles['labels__item']} key={index}>
          <ArticleParagraph3>{label}</ArticleParagraph3>
        </li>
      ))}
    </ul>
  );
}
